import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'zh-HK';
    document.title = '音樂備課寶™｜香港音樂老師 6 合 1 教學系統（小一至中三）';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3ijpe138b53at">
      <div lang="zh-HK" className="w-full overflow-x-clip bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3mlat8v8bdto6">
        <CountdownBar data-id="element-2" data-mp="3rbrcwx2qabiz" />
        <main data-id="element-3" data-mp="3rdkgg3i1ofmr">
          <Hero data-id="element-4" data-mp="3rd1azm9kzjpm" />
          <InsidePages data-id="element-5" data-mp="3reltuemj9e7n" />
          <StatsBar data-id="element-6" data-mp="5orv1p50w72" />
          <Difference data-id="element-7" data-mp="682rygdekbl" />
          <Recognize data-id="element-8" data-mp="5ggje8nxyxz" />
          <WhatsInside data-id="element-9" data-mp="82ovg3doih9" />
          <Bonuses data-id="element-10" data-mp="2zld2xbxu5jcl" />
          <HowItWorks data-id="element-11" data-mp="2zlv8x0aavbxp" />
          <Audience data-id="element-12" data-mp="2zmo557bmuj1l" />
          <Offer data-id="element-13" data-mp="2zn6biws0edn8" />
          <Guarantee data-id="element-14" data-mp="33mow1rfx4mpj" />
          <Faq data-id="element-15" data-mp="33m5eibu6k0c1" />
          <FinalCta data-id="element-16" data-mp="33nq5jrhad155" />
        </main>
        <Footer data-id="element-17" data-mp="33orik1hv3xpi" />
      </div>
    </MotionConfig>;
}